import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Why Get a Web3 App Development For Your <span>Business</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              Investing in Web3 application development for your business
              creates a transparent environment by removing dependency on
              central authorities and ensures resilience against network
              disruptions.
            </p>
            <p>
              Web3, which combines big data and artificial intelligence, speeds
              up operations and effortlessly links the digital and physical
              sectors for improved security. Here are the reasons why you should
              get a Web3 app for your business:
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Data Ownership</h6>
                <p>
                  Web3 manages data utilizing technologies like blockchain
                  [distributed peer-to-peer networks] and smart contracts,
                  allowing users to own their data.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>High Security</h6>
                <p>
                  Web 3.0 is a highly secure network that encrypts information
                  using blockchain, smart contracts, and security measures.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Interoperability</h6>
                <p>
                  Web3 applications link and communicate with other blockchains
                  to offer open access to all types of data.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Transparency</h6>
                <p>
                  Decentralized identification and permission access give users
                  authority over their data.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>TPersonalization</h6>
                <p>
                  Allow users to access their data with public addresses and
                  private keys.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Uninterrupted Services</h6>
                <p>
                  Web3 data stored on dispersed nodes guarantees continuous
                  access, without interruptions from network or service outages,
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
